import React from "react";
import style from "./index.module.scss";
import { Button, Divider, message, Modal, Tooltip } from "antd";
import moment from "moment";
import usePromiseCallback from "Utils/usePromiseCallback";
import { errorMessage } from "Utils/useRequest";
import { ExperimentListItem } from "API/navExperiment";
import Status from "./components/Status";
import { ExperiState, goToExperimentUrl } from "API/navExperiment";
import { cancelCloudDesk } from "API/navExperiment";
import { removeCloudDeskTop } from "API/navExperiment";

interface ListItemProps {
    data: ExperimentListItem;
    refreshData: () => void; //刷新列表
}

export default function ListItem({ data, refreshData }: ListItemProps) {
    //前往实验
    function gotoExperiment(url: string) {
        if (data.status !== ExperiState.doing) {
            message.error("尚未到达预约实验的开始时间");
        } else {
            goToExperimentUrl(url);
        }
    }

    //删除预约
    const onDelete = usePromiseCallback(async function () {
        Modal.confirm({
            title: `确认删除“${data.planName}”吗？`,
            content: "实验计划删除后不可恢复，确定要删除吗？",
            onOk: async () => {
                try {
                    await removeCloudDeskTop(data.id);
                    message.success("删除成功!");
                    refreshData();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    });

    //取消预约
    const onCancel = usePromiseCallback(async function () {
        Modal.confirm({
            title: `确认取消预约“${data.planName}”？`,
            content: `预约取消后，在指定时间内将无法使用云桌面进行实验，确认要取消预约吗？`,
            onOk: async () => {
                try {
                    await cancelCloudDesk(data.id);
                    message.success("取消成功!");
                    refreshData();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    });

    return (
        <div className={style.root}>
            <h1 className={style.title}>
                <Tooltip title={data.planName}>{data.planName}</Tooltip>

                <Status status={data.status} />
            </h1>

            <div className={style.info}>
                实验项目 {data.projectName}
                <Divider type="vertical" style={{ background: "#aaa" }} />
                预约数量 {data.useCount}
                {data.beginTime && data.endTime && (
                    <span>
                        <Divider
                            type="vertical"
                            style={{ background: "#aaa" }}
                        />
                        <span>
                            实验时间{" "}
                            {moment(data.beginTime).format("MM-DD HH:mm")} ~{" "}
                            {moment(data.endTime).format("MM-DD HH:mm")}
                        </span>
                    </span>
                )}
            </div>

            {/*0:未开始， 1:进行中， 2:已结束*/}
            <div className={style.tools}>
                {data.status === ExperiState.done && (
                    <Button type="link" onClick={onDelete}>
                        删除
                    </Button>
                )}
                {data.status !== ExperiState.done && (
                    <Button
                        type="link"
                        onClick={() => gotoExperiment(data.url)}>
                        前往实验
                    </Button>
                )}
                {data.status === ExperiState.noStart && (
                    <Button type="link" onClick={onCancel}>
                        取消预约
                    </Button>
                )}
            </div>
        </div>
    );
}
